import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { AppRemixIcon } from '@/layout/AppComponents';

export default function DeleteModal(props) {
  const {
    show,
    type,
    onClose,
    onConfirm,
    size = 'md',
    title = 'Confirmar eliminar',
    text = '¿Seguro que desea eliminar el elemento seleccionado?',
    sensitive = false,
    sensitiveWord = 'delete me',
  } = props;
  const handleClose = () => onClose(false);
  const handleConfirm = () => onConfirm();
  const [removeButtonDisabled, setRemoveButtonDisabled] = useState(sensitive);

  const iconType = () => {
    switch (type) {
      case 'danger':
        return <AppRemixIcon icon="alert" color="red" className="mr-2" />;
      case 'info':
        return (
          <AppRemixIcon icon="ïnformation" color="blue" className="mr-2" />
        );
      default:
        return '';
    }
  };

  const handleSensitiveCase = (value) => {
    if (value === sensitiveWord) setRemoveButtonDisabled(false);
    else setRemoveButtonDisabled(true);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size={size}>
        <Modal.Header closeButton>
          <Modal.Title>
            <AppRemixIcon icon="delete-bin" color="#dc3545" className="mr-2" />
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            {text}
            <br />
            <br />
            {sensitive && (
              <>
                <p>
                  Por seguridad, para eliminar este elemento, debe escribir{' '}
                  <b>'{sensitiveWord}'</b> en el siguiente campo.
                </p>
                <div className="row">
                  <div className="col-sm-12">
                    <input
                      onChange={(e) => handleSensitiveCase(e.target.value)}
                      className="form-control mb-2"
                    />
                  </div>
                </div>
              </>
            )}
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            variant={'danger'}
            onClick={handleConfirm}
            disabled={removeButtonDisabled}
          >
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
